import { combineReducers } from "redux";
import type { SalesforceIntegrationState } from "./salesforceIntegration";
import { salesforceIntegrationReducer } from "./salesforceIntegration";
import type {
    SuppressionListState } from "app/pages/sales-intelligence/sub-modules/management/store/reducers/suppressionList";
import {
    suppressionListReducer
} from "app/pages/sales-intelligence/sub-modules/management/store/reducers/suppressionList";
import type { HubspotIntegrationState } from "./hubspotIntegration";
import { hubspotIntegrationReducer } from "./hubspotIntegration";
import type { DynamicsIntegrationState } from "./dynamicsIntegration";
import { dynamicsIntegrationReducer } from "./dynamicsIntegration";
import { salesforceExportReducer } from "./salesforceExport";
import { dynamicsExportReducer } from "./dynamicsExport";
import type { ManageIntegrationModalType } from "./manageIntegrationModal";
import { manageIntegrationModalReducer } from "./manageIntegrationModal";
import type { HubspotExportState, DynamicsExportState, CommonManagementStateType, SalesforceExportState, CrmListsState } from "../type";
import { hubspotExportReducer } from "./hubspotExport";
import { commonManagementReducer } from "./common";
import { crmListsReducer } from "./crmLists";

export type ManagementState = {
    suppressionList: SuppressionListState;
    salesforceIntegration: SalesforceIntegrationState;
    hubspotIntegration: HubspotIntegrationState;
    dynamicsIntegration: DynamicsIntegrationState;
    salesforceExport: SalesforceExportState;
    hubspotExport: HubspotExportState;
    dynamicsExport: DynamicsExportState;
    manageIntegrationModal: ManageIntegrationModalType;
    common: CommonManagementStateType;
    crmLists: CrmListsState;
};

export const managementReducer = combineReducers<ManagementState>({
    suppressionList: suppressionListReducer,
    salesforceIntegration: salesforceIntegrationReducer,
    hubspotIntegration: hubspotIntegrationReducer,
    dynamicsIntegration: dynamicsIntegrationReducer,
    salesforceExport: salesforceExportReducer,
    hubspotExport: hubspotExportReducer,
    dynamicsExport: dynamicsExportReducer,
    manageIntegrationModal: manageIntegrationModalReducer,
    common: commonManagementReducer,
    crmLists: crmListsReducer,
});
